export default __webpack_public_path__ + "static/media/workout-3.09df4a6a.jpg";